import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'

const About = () => {

    return (
        <>

            <h1 className="title">
                <Link to="/">SkidCoin</Link>
            </h1>

            <motion.div className="container About"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    <div className="page-content">

                        <h2 className="h2">ETHOS</h2>
                        <p className="description">A Community of Creatives,<br /> Developers and Entrepreneurs.</p>
                        <h2 className="h2">PATHOS</h2>
                        <p className="description">Focused on sustainability.<br /> Improving the lives of our community<br /> and the world.</p>
                        <h2 className="h2">LOGOS</h2>
                        <p className="description">Leveraging web3 technology.</p>

                    </div>

                </main>

            </motion.div>
        </>
    );
}

export default About
